import React from "react";
import { NOTIFICATION_APPEARANCE } from "@shared/interfaces";
import { Icon } from "@shared/components/Icon";

import "./index.scss";

export interface ToastProps {
  appearance: NOTIFICATION_APPEARANCE;
  children: React.ReactNode;
  onDismiss: () => void;
}

const Toast = ({ appearance, children, onDismiss }: ToastProps) => {
  const close = () => {
    setTimeout(() => {
      onDismiss();
    }, 0);
  };

  return (
    <div className={`notification ${appearance}`}>
      <div className={`notification-img ${appearance}`} />
      <div className="notification-message">{children}</div>
      <Icon type="white-cancel" onClick={close} />
    </div>
  );
};

export default Toast;
